import React from 'react'

import Iframe from '../Iframe'

import styles from './videoSection.module.scss'

interface VidoSectionProps {
  title: string
  description: string
  video: string
  theme?: string
  right?: boolean
  loop?: boolean
  autoPlay?: boolean
  withIframe?: boolean
  style?: React.CSSProperties
  className?: string
}

const VideoSection: React.FC<VidoSectionProps> = props => {
  const {
    title,
    description,
    video,
    theme,
    right,
    loop,
    autoPlay,
    withIframe,
    style,
    className,
  } = props
  return (
    <div
      className={
        className ? `${styles.tipsPanel} ${className}` : `${styles.tipsPanel}`
      }
      style={style}
    >
      <div className={right ? styles.right : styles.left}>
        <div
          className={styles.design}
          style={
            theme
              ? { background: theme }
              : {
                  background:
                    'radial-gradient(circle at bottom left,#ff54b1 20%,#ff9cfb)',
                }
          }
        />
        <div
          className={
            withIframe
              ? `${styles.videoBlock} ${styles.iframe}`
              : styles.videoBlock
          }
        >
          {withIframe ? (
            <Iframe src={video} />
          ) : (
            <video
              controls={true}
              loop={loop}
              src={video}
              autoPlay={autoPlay}
            />
          )}
        </div>
      </div>
      <div className={right ? `${styles.title} ${styles.right}` : styles.title}>
        <div className={styles.inner}>
          <h4>{title}</h4>
          <p>{description}</p>
        </div>
      </div>
    </div>
  )
}

export default VideoSection
